import { Box, Container, Typography } from '@mui/material';
import DataFilter from '../../components/DataFilter';
import CardMedico from "./CardMedico";
import { categorias, dataEspecialistas } from "../../data/dataMedicos";
import {ScrollStatic} from "../../components/common/ScrollItem";
import TextToSpeech from "../../components/TextToSpeech";

const Especialidades = () => {
    const accessibilityText = `
      Consulta nuestro directorio medico en la barra de busquedas, tambien puedes filtrar por tipo y en orden alfabetico.
    `;
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        backgroundSize: "100% 20%",
        backgroundRepeat: "no-repeat",
        mb: { xs: "5px", sm: "10px" },
        overflow: "auto",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 15 },
          maxWidth: "100% !important",
          pl: "0 !important",
          pr: "0 !important",
        }}
      >
        {/* <TextToSpeech text={accessibilityText} /> */}

        <ScrollStatic>
          <Typography
            variant="h1"
            align="center"
            sx={{
              width: "100%",
              color: "#194AC1",
              p: "0 35px"
            }}
          >
            Directorio Médico
          </Typography>
        </ScrollStatic>

        <ScrollStatic>
          <DataFilter categoriasList={categorias} categoriaIgual1="especialidad" categoriaIgual2="subespecialidad" categoriaIgual3="subespecialidad" dataItem={dataEspecialistas} dataBusqueda="nombre" labelBusqueda={"Buscar médico / especialidad"} labelSelect={"Especialidad"} ComponentView={CardMedico} GridXs={12} GridSm={6} GridMd={4} GridLg={3} />
        </ScrollStatic>

      </Container>
    </Box>
  );
};

export default Especialidades